import PageModule from "@eisinc/Overrides/Pages/CompactHeader";

export * from "@eisinc/Overrides/Pages/CompactHeader";

export default PageModule;
